import classNames from 'classnames';
import React from 'react';

import styles from './SkeletonLoader.module.scss';

export interface SkeletonLoaderArea {
  className?: string;
  styles?: React.CSSProperties;
}

export interface SkeletonLoaderProps {
  withWrapper?: boolean;
  areas?: SkeletonLoaderArea[];
  defaultView?: boolean;
  className?: string;
}

export const SkeletonLoader = ({
  areas = [],
  withWrapper,
  defaultView,
  className,
  ...rest
}: SkeletonLoaderProps) => {
  const loadingAreas = defaultView ? (
    <>
      <div className={styles.defaultTitle} data-testid="default-view-title" />
      <div className={styles.defaultContent} />
    </>
  ) : (
    areas.map((area, idx) => (
      <div
        key={idx}
        className={classNames(styles.area, area.className)}
        style={area.styles}
        data-testid="loading-area"
      />
    ))
  );

  const wrapperClassName = classNames(
    styles.wrapper,
    {
      [styles.wrapperWithWrapper]: withWrapper && !defaultView,
      [styles.wrapperDefaultView]: defaultView,
    },
    className
  );

  return (
    <section className={wrapperClassName} {...rest}>
      {loadingAreas}
    </section>
  );
};
